import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import StudentInvoice from "./StudentInvoice";

const StudentInvoiceLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Invoices" />
      <StudentInvoice />
    </MasterLayout>
  );
};

export default StudentInvoiceLayout;
